import React from 'react';
import { countBy } from 'lodash-es';
import { 
  PieChart,
  Pie,
  ScatterChart,
  XAxis,
  YAxis,
  ZAxis,
  Scatter,
  Tooltip,
} from 'recharts';
import styled from 'styled-components';
import ChartPie from './Vis/ChartPie';
import {
  tb_Categoria,
  tb_Vinculo,
  tb_TipoEndereco,
  tb_EstadoCivil,
  tb_Sexo,
  tb_GrauInstrucao,
} from './tabelas';
import { contaAnos } from '../../Helpers/date';
import { getColor } from '../../Common/Cores';

let x = getColor()
let setCor = () => x.next().value


const Grid = styled.div`
  display: grid;
  grid-template-columns: 400px 400px;
`

let coresSindicato = k => {
  return setCor();
}

let coresSexo = k => {
  if (k == 'M') return 'blue';
  if (k == 'F') return 'pink';
}

let coresEstadoCivil = k => {
  if (k=='C') return 'purple';
  if (k=='S') return 'gray';
  if (k=='V') return 'blue';
  if (k=='D') return 'orange';
}

function formatDataToChartPie (srcData, opts={}) {
  let {cores={}, tabela={}} = opts;
  return Object.entries(srcData).map(([k,v]) => {
    let nome = tabela[k] || k
    return {
      'Nome': nome,
      'value': v,
      'Cor': cores(k),
      'Id': k
    }
  })
}

function formatDataToCharts (srcData, opts={}) {
  const { ZAxis } = opts;
  let others = ZAxis ? { 'index': 1 } : {};
  return Object.entries(srcData).map(([k,v]) => ({
    'name': k,
    'value': v,
    ...others
  }))
}

const parseDomain = (data) => [
  0,
  Math.max.apply(null, data.map(entry => entry.value)),
];


export default function (props) {
  const { funcionarios } = props;
  // let porSexo = formatDataToCharts(countBy(funcionarios, 'Sexo'));
  let porSexo = formatDataToChartPie(countBy(funcionarios, 'Sexo'), { cores: coresSexo, tabela: tb_Sexo });
  let porEstadoCivil = formatDataToChartPie(countBy(funcionarios, 'EstadoCivil'), { cores: coresEstadoCivil, tabela: tb_EstadoCivil });
  let porSindicato = formatDataToChartPie(countBy(funcionarios, 'Sindicato'), { cores: coresSindicato });
  // let porEstadoCivil = formatDataToCharts(countBy(funcionarios, 'EstadoCivil'));
  // let porAnoAdmissao = formatDataToCharts(countBy(funcionarios, o => new Date(o.Admissao).getFullYear()), { ZAxis: true });
  let porTempoDeCasa = formatDataToCharts(countBy(funcionarios, o => contaAnos(new Date(o.Admissao))), { ZAxis: true });
  // let porAnoNascimento = formatDataToCharts(countBy(funcionarios, o => new Date(o.DataNascimento).getFullYear()), { ZAxis: true });
  let porIdade = formatDataToCharts(countBy(funcionarios, o => contaAnos(new Date(o.DataNascimento))), { ZAxis: true });
  let porTempoDeCasa_domain = [
    parseInt(porTempoDeCasa[0].name),
    parseInt(porTempoDeCasa[porTempoDeCasa.length - 1].name) + 1,
  ]
  // let porAnoAdmissao_domain = [
  //   parseInt(porAnoAdmissao[0].name),
  //   parseInt(porAnoAdmissao[porAnoAdmissao.length - 1].name) + 1,
  // ]
  let porIdade_domain = [
    parseInt(porIdade[0].name),
    parseInt(porIdade[porIdade.length - 1].name) + 1,
  ]

  const renderTooltip = prefixo => props => {
    const { active, payload } = props;

    if (active && payload && payload.length) {
      const data = payload[0] && payload[0].payload;
      let seP1 = (data.name > 1) && 's' //plural 1 's'
      let seP2 = (data.value > 1) && 'es' //plural 2 'es'
      return (
        <div style={{
          backgroundColor: '#fff', border: '1px solid #999', margin: 0, padding: 10,
        }}
        >
          <p>
            {data.value} colaborador{seP2} com {data.name} ano{seP1} de {prefixo}
          </p>
        </div>
      );
    }

    return null;
  }
  const domainIdade = parseDomain(porIdade);
  const domainTempoDeCasa = parseDomain(porTempoDeCasa);
  const range = [0, 200];

  return (
    <div>
      <h1 style={{textAlign: 'center'}}>Informações sobre a equipe</h1>
      <h3>Por tempo de casa:</h3>
      <div>
        <ScatterChart
          width={600}
          height={60}
          margin={{
            top: 10, right: 10, bottom: 0, left: 10,
          }}
        >
          {/* ticks={lodash.range(2005,2021)} */}
          <XAxis
            type="number"
            dataKey="name"
            name="name"
            interval={0}
            tick={{fontSize: '10px'}}
            tickLine={{ transform: 'translate(0, -6)' }}
            domain={porTempoDeCasa_domain} 
          />
          <YAxis
            type="number" dataKey="index" height={10} width={40} tick={false} tickLine={false} axisLine={false} />
          <ZAxis type="number" dataKey="value" domain={domainTempoDeCasa} range={range} />
          <Tooltip cursor={{ strokeDasharray: '3 3' }} wrapperStyle={{ zIndex: 100 }} content={renderTooltip('admitido')} />
          <Scatter data={porTempoDeCasa} fill="#8884d8" />
        </ScatterChart>
      </div>
      {/* <div>
        {Object.entries(countBy(funcionarios, o => new Date(o.Admissao).getFullYear())).map(([k,v]) => <div>{k}: {v}</div>)}
      </div> */}
      <div>
        <h3>Por idade:</h3>
        <div>
          <ScatterChart
            width={600}
            height={60}
            margin={{
              top: 10, right: 10, bottom: 0, left: 10,
            }}
          >
            <XAxis type="number" dataKey="name" name="name" interval={0} tick={{fontSize: '10px'}} tickLine={{ transform: 'translate(0, -6)' }} domain={porIdade_domain} />
            <YAxis type="number" dataKey="index" height={10} width={40} tick={false} tickLine={false} axisLine={false} />
            <ZAxis type="number" dataKey="value" domain={domainIdade} range={range} />
            <Tooltip cursor={{ strokeDasharray: '3 3' }} wrapperStyle={{ zIndex: 100 }} content={renderTooltip('vida')} />
            <Scatter data={porIdade} fill="#8884d8" />
          </ScatterChart>
        </div>
        {/* {Object.entries(countBy(funcionarios, o => new Date(o.DataNascimento).getFullYear())).map(([k,v]) => <div>{k}: {v}</div>)} */}
      </div>
      <Grid>
        <div>
          <h3>Por sexo: </h3>
          <ChartPie
            data={porSexo}
            dataKey={'value'}
          />
        </div>
        <div>
          <h3>Por estado civil: </h3>
          <ChartPie
            data={porEstadoCivil}
            dataKey={'value'}
          />
        </div>
      </Grid>
      <div>
        <h3>Por sindicato:</h3>
        <div>
          <ChartPie
            data={porSindicato}
            dataKey={'value'}
            width={750}
            legendItemCss={`max-width: 540px;`}
          />

        </div>
      </div>
      <div style={{ paddingBottom: '80px'}}></div>

        {/* <PieChart width={730} height={250}> */}
          {/* <Pie data={porEstadoCivil} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={30} outerRadius={50} fill="#8884d8" label /> */}
          {/* <Pie data={data02} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label /> */}
        {/* </PieChart> */}
      {/* <div>
        {Object.entries(countBy(funcionarios, 'EstadoCivil')).map(([k,v]) => <div>{k}: {v}</div> )}
      </div> */}
      {/* <div>
        Por "Sindicato":
        {Object.entries(countBy(funcionarios, 'Sindicato')).map(([k,v]) => <div>{k}: {v}</div> )}
      </div> */}

      {/* <div>
        Por "Cargo":
        {Object.entries(countBy(funcionarios, 'Cargo')).map(([k,v]) => <div>{k}: {v}</div> )}
      </div>
      <div>
        Por "NomeJornada":
        {Object.entries(countBy(funcionarios, 'NomeJornada')).map(([k,v]) => <div>{k}: {v}</div> )}
      </div> */}
    </div>
  )
}


// Por ano de "Admissao",
// Por faixa de "Salario",
// //Por "Sexo",
// // Por "EstadoCivil",
// // Por "Cargo",
// // Por "Sindicato",
// // Por "NomeJornada",
// Por faixa etária "DataNascimento",


// [
//   "CodigoEmpresa",
//   "Codigo",
//   "CodigoFilial",
//   "Nome",
//   "Categoria",
//   "Endereco",
//   "TipoEndereco",
//   "NumEndereco",
//   "Bairro",
//   "Complemento",
//   "CEP",
//   "DDDTelefone",
//   "Telefone",
//   "DDDCelular",
//   "Celular",
//   "UF",
//   "VencimentoFerias",
//   "LocalNascimento",
//   "LocalNascimentoUF",
//   "Nacionalidade",
//   "VinculoEmpregaticio",
//   "DptoID",
//   "Email",
//   "RG",
//   "PIS",
//   "CPF",
//   "CarteiraTrabalho",
//   "GrauInstrucao",
//   "CodSindicato",
//   "HorasSemana",
//   "HorasDia",
//   "HorasMes",
//   "Deficiente",
//   "Foto",
//   "Cidade",
//   "SindicatoTelefone",
//   "SindicatoMesBase",
//   "Reajustes"
// ]